<template>
  <div>
    <app-spinner v-if="!is_loaded"/>
    <template v-else>
      <app-cells>
        <h1 class="title">{{ profile.first_name }} {{ profile.last_name }}</h1>
      </app-cells>
      <app-tabs :tabs="tabs"/>
      <transition mode="out-in" name="fade">
        <router-view
          :personal="personalDataDistribution()"
          :documents="documentsDataDistribution()"
          :position="positionDataDistribution()"
        />
      </transition>
    </template>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs.vue'
import { getClimbingMountainCrewDetail } from '@/http'

export default {
  name: 'ClimbingMountainCrewDetailLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'climbing-mountain-crew-profile', label: 'Profile' },
        { name: 'climbing-mountain-crew-documents', label: 'Documents' },
        { name: 'climbing-mountain-crew-position', label: 'Position' },
      ],
      is_loaded: false,
      profile: {}
    }
  },
  created() {
    getClimbingMountainCrewDetail(this.$route.params.id).then(response => {
      this.profile = response.data
      this.is_loaded = true
    })
  },
  methods: {
    personalDataDistribution() {
      return {
        first_name: this.profile.first_name,
        middle_name: this.profile.middle_name,
        last_name: this.profile.last_name,
        village: this.profile.village,
        region: this.profile.region,
        dob: this.profile.dob,
        birth_certificate: this.profile.birth_certificate,
        gender: this.profile.gender,
        crop: this.profile.crop,
        email: this.profile.email,
        phone: this.profile.phone,
        phone_telegram_available: this.profile.phone_telegram_available,
        phone_whatsapp_available: this.profile.phone_whatsapp_available,
        additional_phone: this.profile.additional_phone,
        additional_phone_telegram_available: this.profile.additional_phone_telegram_available,
        additional_phone_whatsapp_available: this.profile.additional_phone_whatsapp_available,
        telegram_id: this.profile.telegram_id,
        telegram_username: this.profile.telegram_username,
      }
    },
    documentsDataDistribution() {
      return {
        national_id: this.profile.national_id,
        national_id_expire: this.profile.national_id_expire,
        national_id_scancopy: this.profile.national_id_scancopy,
        voting_card: this.profile.voting_card,
      }
    },
    positionDataDistribution() {
      return {
        role: this.profile.role,
        guarantor_crew: this.profile.guarantor_crew,
        bank_account: this.profile.bank_account,
      }
    },
  }
}
</script>
